import { Phone } from "lucide-react";
import { PHONE_TEL } from "@/lib/site";

export default function MobileDialer() {
  return (
    <div className="pb-safe fixed inset-x-0 bottom-0 z-50 border-t border-line glass px-3 py-2.5 md:hidden">
      <div className="flex">
        <a
          href={PHONE_TEL}
          data-testid="mobile-bottom-call-button"
          className="flex flex-1 items-center justify-center gap-2 rounded-full bg-volt font-display text-sm font-extrabold text-night shadow-[0_4px_24px_rgba(255,195,0,0.35)] active:scale-95"
          style={{ height: 52 }}
        >
          <Phone size={18} strokeWidth={2.5} />
          Chiama ora · 06 85902421
        </a>
      </div>
    </div>
  );
}
